/* @flow */
/* eslint import/prefer-default-export: 0 */

import * as settingsApi from '../api/settings';
import * as types from '../constants/actionTypes';
import { SETTINGS_BANNERS } from '../constants/apiTypes';

export function getBanners() {
  return {
    type: types.API_CALL,
    api: SETTINGS_BANNERS,
    request: settingsApi.getBanners()
  };
}
